<main>
    <section id="main__destaque" *ngIf="!isMobile">
      <video #video class="video" alt="Vídeo de pessoas sentadas em reuniao" oncanplay="this.play()" onloadedmetadata="this.muted = true" loop>
        <source src="assets/gifs/reuniao-video-index.mp4" type="video/mp4">
      </video>
    </section>
    <section class="main__sobre_nos">
        <div class="main__sobre_nos_texto">
            <h1 *ngIf="!isMobile" >Primecap</h1>
            <p>Somos uma plataforma de investimentos coletivos, regulada e autorizada pela <strong>CVM</strong> Oferecemos e democratizamos as melhores oportunidades de investimentos na economia real (Empresas & Imóveis) a partir de <strong>R$ 1.000</strong>,  para você diversificar sua carteira de investimentos e ser sócio de projetos exclusivos e promissores!</p>
        </div>
        <div class="main__sobre_nos_imagem" *ngIf="!isMobile">
            <img src="assets/images/primecap_logo_branco_sem_fundo.png" alt="logo primecap">
        </div>
    </section>
    <section class="main__oportunidades">
        <h1 class="main__oportunidades_h1">Oportunidades</h1>
        <div>
            <div>
                <div class="main__oportunidades_tipos">
                    <img src="assets/images/tela-celular.webp" alt="Aplicativos na tela do Celular">
                    <div>
                        <h2>Startups</h2>
                        <p>Investir em startups pode ser uma estratégia financeira promissora por várias razões. Primeiro, as startups têm um potencial significativo de crescimento e inovação. Elas são empresas emergentes com ideias disruptivas e soluções inovadoras, muitas vezes impulsionadas pela tecnologia. Ao investir em uma startup bem-sucedida, você pode obter retornos financeiros substanciais à medida que ela se expande e se torna uma empresa estabelecida. Além disso, investir em startups permite que você diversifique sua carteira de investimentos. Normalmente, as startups têm um perfil de risco mais alto, mas também oferecem a possibilidade de recompensas mais elevadas. Ao alocar uma parte de seus investimentos em startups, você reduz a dependência de ativos tradicionais, como ações e opções, e aumenta suas chances de obter ganhos significativos.</p>
                    </div>
                </div>
                <div class="main__oportunidades_tipos">
                    <img src="assets/images/arquitetos-planejando-construcao.webp" alt="Arquitetos planejando construcao">
                    <div>
                        <h2>Real Estate</h2>
                        <p>Investir na construção de imóveis é uma estratégia interessante por diversas razões. Primeiramente, a construção oferece a oportunidade de criar ativos tangíveis. Ao investir nesse setor, você está envolvido diretamente na criação de propriedades físicas, que têm valor intrínseco e geram ganhos de capital interessantes através da venda. A construção de imóveis pode servir como uma forma de diversificação de investimentos, estará adicionando uma classe de ativos diferente ao seu portfólio que tendem a ter um desempenho relativamente estável e, em certos momentos, podem até funcionar como uma proteção contra a inflação.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="main__o_que_oferecemos">
        <h1 class="">Oferecemos</h1>
        <div class="main__o_que_oferecemos_lista_cards">
            <div class="main__o_que_oferecemos_cards">
                <img src="assets/images/grafico-pizza.webp" alt="grafico pizza">
                <h3>Diversificação de portfólio</h3>
                <p>Através da Primecap, você pode investir a partir de R$ 1.000 e construir um portfólio diversificado de investimentos direto na economia real, mitigando riscos e aumentando a possibilidade de retornos.</p>
            </div>
            <div class="main__o_que_oferecemos_cards">
              <img src="assets/images/engenheiros-de-robotica.webp" alt="engenheiros de robotica">

              <h3>Oportunidades exclusivas</h3>
              <p>As ofertas disponíveis na Primecap são exclusivas, e você não encontra em outro lugar. As cotas e o período de cada rodada é limitado, cada oportunidade é única e todas passam por um estrito processo de análise e due-diligence antes de serem publicadas, além de que todas rodadas são devidamente registradas na CVM.</p>
            </div>
            <div class="main__o_que_oferecemos_cards">
                <img src="assets/images/agentes-de-seguros.webp" alt="agentes de seguro em reuniao">

                <h3>Assessores qualificados</h3>
                <p>A Primecap trabalha em parceria com os melhores escritórios de assessoria de investimentos, qualificados e antenados no  mercado de startups e real estate, prontos para te assessorar a analisar os projetos e montar o portfólio ideal  para o seu perfil de investidor.</p>
            </div>
        </div>
    </section>

  <footer-primecap></footer-primecap>

</main>
